import { render, staticRenderFns } from "./abstrRegistList.vue?vue&type=template&id=9f8d19c4&scoped=true&"
import script from "./abstrRegistList.vue?vue&type=script&lang=js&"
export * from "./abstrRegistList.vue?vue&type=script&lang=js&"
import style0 from "./abstrRegistList.vue?vue&type=style&index=0&id=9f8d19c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8d19c4",
  null
  
)

export default component.exports